import Vue from 'vue'

export async function getDepartments ({ commit }) {
  try {
    commit('shared/setError', false, { root: true })
    commit('setDepartments', null)
    const { data } = await Vue.axios({
      url: '/v1/regions'
    })
    commit('setDepartments', data)
  } catch (error) {
    commit('shared/setError', error, { root: true })
  }
}

export async function getCities ({ commit }, departmentID) {
  try {
    commit('shared/setError', false, { root: true })
    commit('setCities', null)
    const { data } = await Vue.axios({
      url: `/v1/regions/${departmentID}`
    })
    commit('setCities', data)
  } catch (error) {
    commit('shared/setError', error, { root: true })
  }
}

export async function getDeliveryTypes ({ commit }, { cityID, totalValue }) {
  try {
    commit('shared/setError', false, { root: true })
    commit('shared/setLoading', true, { root: true })
    commit('setShippingInfo', null)
    commit('setDeliveryTypes', null)

    const { data } = await Vue.axios({
      url: `/v1/delivery-types/${cityID}?total_value=${totalValue}`
    })

    commit('setDeliveryTypes', data)
    commit('buildShippingInfo', { deliveryTypes: data, totalValue: totalValue })
  } catch (error) {
    commit('shared/setError', error, { root: true })
  } finally {
    commit('shared/setLoading', false, { root: true })
  }
}
